import styled from "styled-components";

export const Container = styled.div`
  padding: 0 30px 30px 30px;

  & .upload-wrapper {
    margin-top: 20px;
  }
`;
